// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"C_TheComp__vsRHR"};